import axiosInstance from './AxiosInstance';

export function getPartnerVaultBalance(partnerId) {
    return axiosInstance.get(`partner/${partnerId}/get-milipot-balance`);
}

export function getTotalUserWalletBalance(partnerId) {
    return axiosInstance.get(`partner/${partnerId}/get-total-user-wallet-balance`);
}

export function getUserWalletBalance(userId) {
    return axiosInstance.get(`user/${userId}/get-user-wallet-balance`);
}

export function topUpPartnerVault(partnerId, data) {
  return axiosInstance.post(`ledger/partners/${partnerId}/top-up`, data);
}

export function getUserWalletBalances(partnerId) {
  return axiosInstance.get(`partner/${partnerId}/user-wallet-balances`);
}

export function getPaginatedUserWalletBalances(partnerId, page, search = '') {
  return axiosInstance.get(`partner/${partnerId}/user-wallet-balances`, {
    params: { page, ...(search ? { search } : {}) },
  });
}

export function disburseToUserWallet(partnerId, data) {
  return axiosInstance.post(`ledger/partners/${partnerId}/disburse`, data);
}

export function requestUserWalletTopUp(partnerId, data) {
  return axiosInstance.post(`partner/${partnerId}/user-wallet/request-top-up`, data);
}

export function getPartnerVaultTopUpCount(partnerId) {
  return axiosInstance.get(`partner/${partnerId}/get-milipot-top-up-count`);
}

export function getUserWalletTopUpCount(userId) {
  return axiosInstance.get(`user/${userId}/get-user-wallet-top-up-count`);
}

export function getUserWalletOutflowsByPartner(partnerId) {
  return axiosInstance.get(`partner/${partnerId}/count-user-wallet-outflows-by-partner`);
}

export function getUserWalletOutflows(userId) {
  return axiosInstance.get(`user/${userId}/count-user-wallet-outflows`);
}

export function getTopSpenders(partnerId, startDate, endDate) {
  const params = {};
  if (startDate) params.start_date = startDate;
  if (endDate) params.end_date = endDate;
  return axiosInstance.get(`partner/${partnerId}/top-spenders`, { params });
}

export function payThroughPaybill(userId, data) {
  return axiosInstance.post(`ledger/users/${userId}/pay/type/pay-via-paybill-or-till`, data);
}

export function payThroughSendMoney(userId, data) {
  return axiosInstance.post(`ledger/users/${userId}/pay/type/pay-via-send-money`, data);
}

export function payThroughPochiLaBiashara(userId, data) {
  return axiosInstance.post(`ledger/users/${userId}/pay/type/pay-via-pochi-la-biashara`, data);
}

export function lookupPayoutRecipient(userId, payoutType, partyB, accountReference = '') {
  return axiosInstance.get(`ledger/users/${userId}/payout-recipients/lookup`, {
    params: { payout_type: payoutType, party_b: partyB, account_reference: accountReference },
  });
}

export function getUserTransactionLimits(partnerId, userId) {
  return axiosInstance.get(`partners/${partnerId}/users/${userId}/transaction-limits`);
}

export function getUserExpenseTagStats(userId, startDate) {
  const params = {};
  if (startDate) params.start_date = startDate;
  return axiosInstance.get(`user/${userId}/expense-tag-stats`, { params });
}
